import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className='quote-card-view'>
      <Card.Body>
        <blockquote className='blockquote mb-0'>
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className='purple'>Meet Parmar </span>
            from <span className='purple'> Mumbai, India.</span>
            <br />I am a currently pursuing Computer Engineering.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className='about-activity'>
              <ImPointRight /> Playing Online Games
            </li>
            <li className='about-activity'>
              <ImPointRight /> Listening to Music.
            </li>
            <li className='about-activity'>
              <ImPointRight /> Writing
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "If Opportunity doesn't Knock, Build a Door."{" "}
          </p>
          <footer className='blockquote-footer'>Meet</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
